import React from "react";
import "./Stop_Waiting.css";

const Stop_Waiting = () => {
  return (
    <>
      <section className="Stop_Waiting">
        <div className="container">
          <div className="main_content_div">
            <div className="first_div">
              <p className="section_title">STOP WAITING</p>

              <div className="mobile_img_div">
                <img
                  src="assets/images/stop_waiting/mobile.png"
                  alt="mobile"
                  className="mobile_img"
                />
              </div>
            </div>

            <div className="second_div">
              <div className="inner_second_div">
                <p className="section_title_new">START BOOKING</p>

                <div className="all_imgs_holder">
                  <div className="img1_div innder_div">
                    <img
                      src="/assets/images/stop_waiting/3.png"
                      className="left_img inner_img"
                    />
                  </div>

                  <div className="img2_div innder_div">
                    <img
                      src="/assets/images/stop_waiting/1.png"
                      className="center_img inner_img"
                    />
                  </div>

                  <div className="img3_div innder_div">
                    <img
                      src="/assets/images/stop_waiting/2.png"
                      className="right_img inner_img"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="mobile_view_banner">
              <img
                src="/assets/images/stop_waiting/mobileview.png"
                className="mobile_view_image"
                alt="Mobile view"
              />
            </div>

            <div className="download_section">
              <div className="sw-divider">
                <div className="line" />
                <div className="divider-text">Download the App</div>
                <div className="line" />
              </div>
              <div className="sw-badges">
                <div className="sw-badge">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.pmroadcustomer"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sw-badge"
                  >
                    <img
                      src="/assets/images/about_us/Owner.png"
                      alt="Customer App"
                      className="badge-image"
                    />
                  </a>

                  {/* Driver App */}
                  <a
                    href="https://play.google.com/store/apps/details?id=com.pmroaddriver"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sw-badge"
                  >
                    <img
                      src="/assets/images/about_us/User.png"
                      alt="Driver App"
                      className="badge-image"
                    />
                  </a>

                  <a
                    href="https://www.apple.com/app-store/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sw-badge"
                  >
                    <img
                      src="/assets/images/about_us/app_store_user.jpg"
                      alt="app store user"
                      className="badge-image"
                    />
                  </a>
                  <a
                    href="https://www.apple.com/app-store/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sw-badge"
                  >
                    <img
                      src="/assets/images/about_us/app_store_owner.png"
                      alt="app store owner"
                      className="badge-image"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="sw-section">
        <div className="container">
          <div className="sw-content">
            <div className="section-1 ">
              <h2 className="sw-title">STOP WAITING</h2>

              <div className="mobile-div">
                <img
                  src="assets/images/stop_waiting/mobile.png"
                  alt="mobile"
                  className="mobile-img"
                />
              </div>

              <div className="sw-download">
                <div className="sw-divider">
                  <div className="line" />
                  <div className="divider-text">Download the App</div>
                  <div className="line" />
                </div>

                <div className="sw-badges">
                  <div className="sw-badge">
                    <img
                      src="assets/images/stop_waiting/google_play.png"
                      alt="Customer App"
                      className="badge-image"
                    />
                    <div className="badge-label">for Customer</div>
                  </div>

                  <div className="sw-badge">
                    <img
                      src="assets/images/stop_waiting/google_play.png"
                      alt="Driver App"
                      className="badge-image"
                    />
                    <div className="badge-label">for Driver</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="section-2">
              <h2 className="sw-title-hover">START BOOKING</h2>

              <div className="hover-3img-wrapper">
                <div className="hover-img-box">
                  <img
                    src="/assets/images/stop_waiting/1.png"
                    className="hover-img1"
                    alt="img1"
                  />
                </div>

                <div className="hover-img-box">
                  <img
                    src="/assets/images/stop_waiting/2.png"
                    className="hover-img2"
                    alt="img2"
                  />
                </div>

                <div className="hover-img-box">
                  <img
                    src="/assets/images/stop_waiting/3.png"
                    className="hover-img3"
                    alt="img3"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default Stop_Waiting;
